import React, {useState} from "react";
import __ from "lodash";

import {
  ComposableMap,
  Geographies,
  Geography,
  Line,
} from "react-simple-maps";
import {AirportMarker} from "../../../controls/Map";

const geoUrl =
  // "https://raw.githubusercontent.com/zcreativelabs/react-simple-maps/master/topojson-maps/world-110m.json";
  "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const SuggestedRouteMap = (props) => {
  const {
    record, 
    width, 
    height
  } = {
    width: 1000,
    height: 540,
    ...props
  };

  const [state, setState] = useState({
    markers: [],
    route: [],
    projectionConfig: {
      scale: 0, 
      rotation: [0,0,0]
    },
    record: null
  });

  const routeColours = props.routeColours||{};

  if (state.record !== record) {
    if (!record.route || record.route.length < 1) {
      setState({...state, markers: [], route: [], record});
      return;
    };    
    const route = record.route || [];
    const markers = [];
    let smallestLat = null;
    let smallestLong = null;
    let biggestLat = null;
    let biggestLong = null;
    for (let i = 0; i < route.length; i++ ){
      markers.push( { name: route[i].airportCode, coordinates: [route[i].long, route[i].lat] });
      if (smallestLat === null || route[i].lat < smallestLat) smallestLat = route[i].lat;
      if (biggestLat === null || route[i].lat > biggestLat) biggestLat = route[i].lat;
      if (smallestLong === null || route[i].long < smallestLong) smallestLong = route[i].long;
      if (biggestLong === null || route[i].long > biggestLong) biggestLong = route[i].long;
    }
    const routePoints = [];
    for (let i = 1; i < route.length; i++ ){
      const points = [[route[i-1].long, route[i-1].lat],[route[i].long, route[i].lat]];
      routePoints.push(points);
    }

    const widthPercent = (Math.abs(biggestLong - smallestLong));
    const heightPercent = Math.max(9, (Math.abs(biggestLat - smallestLat) * (width/height) * 1.7));
    
    const projectionConfig = {
      scale: (width * 0.9 / (Math.max(widthPercent, heightPercent)/180 * Math.PI)),// (Math.max(widthPercent, heightPercent))),
      center: [(biggestLong + smallestLong)/2, (biggestLat + smallestLat)/2]
    }
    setState({...state, markers, route: routePoints, record, projectionConfig});
    if (props.routeListener) {
      props.routeListener(route);
    }
  }

  if (!state.route || !Array.isArray(state.route) || !state.length < 1) return (<>No Route Found</>);
  const map = (
    <ComposableMap
      width={width}
      height={height}
      projection="geoMercator"
      projectionConfig={state.projectionConfig}
    >
      <Geographies geography={geoUrl}>
        {({ geographies }) =>
          geographies
            .map(geo => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="#DADADA"
                stroke="#B0B0B0"
              />
            ))
        }
      </Geographies>
      {(state.route||[]).map((points, i) => {
        let color = "#000000";
        if (__.has(routeColours, `leg${i}`) && __.has(routeColours[`leg${i}`], 'color')) {
          color = routeColours[`leg${i}`].color;
        }
        return (
          <Line
            coordinates={points}
            stroke={color}
            strokeWidth={3}
            // strokeDasharray={[i, i]}
          />
        )
      })}
      {state.markers.map(({ name, coordinates }) => (
        <AirportMarker fontSize={18} name={name} coordinates={coordinates}/>
      ))}
    </ComposableMap>
  );
  return map;
};

export default SuggestedRouteMap